import { useEffect, useMemo, useRef, useState } from 'react'
import { useSession } from 'next-auth/react'

import axios from 'axios';

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown, faChevronLeft, faCoins, faMapLocationDot, faMinusCircle, faPlusCircle, faPlusSquare, faXmark } from '@fortawesome/free-solid-svg-icons';

import { BarLoader, PulseLoader } from 'react-spinners';

import GridDragAndDrop from '../../../../Misc/GridDragAndDrop/GridDragAndDrop';

import MapWithLocation from '../../../../Misc/MapWithLocation/MapWithLocation';

import NumberFormat from 'react-number-format';

import ToggleSwitch from '../../../../FunctionalComponents/ToggleSwitch';

import errorMsg from '../../../../Functions/errorMsg';

export default function GeneralEvent({ setMapType, handleBack, showPolicyPage, pendingRequest, handleCreateListing }) {

    const { data: session, status } = useSession();

    const [uploads, setUploads] = useState([]);

    const [title, setTitle] = useState('');

    const startDateRef = useRef(new Date());
    const endDateRef = useRef(new Date());

    const [eventAddress, setEventAddress] = useState("");
    const [eventCity, setEventCity] = useState("");
    const [zip, setZIP] = useState('');

    const [phoneNumber, setPhoneNumber] = useState('');

    const [eventFeatures, setEventFeatures] = useState([]);

    const [desc, setDesc] = useState("");

    useEffect(() => {
        if((zip.length === 5 || zip.length === 10) && eventAddress.length >= 8 && eventCity.length >= 3) {
            setMapType({ type: "Location", address: eventAddress, city: eventCity, zip: zip });
        } else {
            setMapType(null);
        }
    }, [zip, eventAddress, eventCity])

    const handleZIPChange = (e) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, '');

        if (inputValue.length > 5) {
          inputValue = inputValue.slice(0, 5) + '-' + inputValue.slice(5);
        }

        inputValue = inputValue.slice(0, 10);

        setZIP(inputValue);
    };

    const featureRef = useRef(null);

    function addEventFeature() {
        if(featureRef?.current?.value?.length === 0) return errorMsg("Enter an amenity you'd like to add");
        const getFeature = featureRef.current.value;
        if(getFeature.length === 0)return errorMsg("Enter an amenity you'd like to add");
        setEventFeatures([...eventFeatures, getFeature]);
        featureRef.current.value = '';
    }

    function removeEventFeature(index) {
        const updatedItems = [...eventFeatures];
        updatedItems.splice(index, 1);
        setEventFeatures(updatedItems);
    }

    const handleChange = (event) => {
        const input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
        let formattedPhoneNumber = '';
        
        if (input.length >= 4 && input.length <= 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3)}`;
        } else if (input.length > 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
        } else {
          formattedPhoneNumber = input;
        }
        
        setPhoneNumber(formattedPhoneNumber);
      };

    const [eventCategory, setEventCategory] = useState('Select Category');
    const [categoryMenu, showCategoryMenu] = useState(false);

    const changeEventCategory = (e, catName) => {
        e.preventDefault();
        if(catName === eventCategory) return;
        setEventCategory(catName);
        showCategoryMenu(false);
    }

    const [acceptPayments, setAcceptPayments] = useState(false);
    const [paymentData, setPaymentData] = useState(null);

    function handleSubmit() {
        if(paymentData !== null && paymentData.status === 'no_account') return errorMsg("You must have a finance account")
        if(paymentData !== null && paymentData.status === 'verified' && paymentData.balance < 20) return errorMsg("You do not have enough x-Coins to accept online payments.");
        if(paymentData !== null && paymentData.status === 'verified' && paymentData.purchaseOptions === null) return errorMsg("Please enter at least 1 item before continuing.");
        if(paymentData !== null && paymentData.status === 'verified' && paymentData.purchaseOptions !== null && paymentData.purchaseOptions.length === 0) return errorMsg("Please enter at least 1 item before continuing.");
            
        const currentDate = new Date();
        const startDate = new Date(startDateRef.current.value);
        const endDate = new Date(endDateRef.current.value);

        if(startDateRef.current.value === '') return errorMsg("Please be sure to enter a date and time for the start date.");
        if(endDateRef.current.value === '') return errorMsg("Please be sure to enter a date and time for the end date.");

        if(startDateRef.current.validity.badInput === true) {
            errorMsg("Please be sure to enter a date and time for the start date.");
            return;
        }

        if(endDateRef.current.validity.badInput === true) {
            errorMsg("Please be sure to enter a date and time for the end date.");
            return;
        }

        if(startDate <= currentDate) {
            errorMsg("Your start date cannot be your current date or less.");
            return;
        }

        if(endDate <= currentDate) {
            errorMsg("Please select an end date that is greater than your current date.");
            return;
        }

        if(startDate >= endDate) {
            errorMsg("Your start date is greater than your end date, please extend your end date.");
            return;
        }

        const listingData = {
            owner: session.user.token.username,
            listArea: 'General',
            title: title,
            description: desc,
            category: eventCategory,
            eventAddress: eventAddress,
            eventCity: eventCity,
            contactPhone: phoneNumber,
            zip: zip,
            eventFeatures: eventFeatures,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            toUpload: uploads,
            creationDate: new Date().toISOString()
        }

        if (acceptPayments === true && paymentData !== null && paymentData.purchaseOptions !== null && paymentData.purchaseOptions.length > 0) {
            listingData.acceptPayments = {
                enabled: true,
                cost: 20,
                purchaseOptions: paymentData.purchaseOptions,
                refundPolicy: paymentData.refundPolicy,
            }
        }

        if(acceptPayments === false) {
            listingData.acceptPayments = {
                enabled: false,
                cost: null,
                purchaseOptions: [],
                refundPolicy: '',
            }
        }

        handleCreateListing(listingData);
    }

    useEffect(() => {
        if(acceptPayments === false) {
            if(paymentData !== null) setPaymentData(null);
        }
    }, [acceptPayments])

    const [canSubmit, setCanSubmit] = useState(false);

    const [confirmGoBack, setConfirmGoBack] = useState(false);

    function handleConfirmBack() {
        if(uploads.length > 0 || (title.length > 5 && title.length <= 50) || desc.length > 15 || eventAddress.length >= 8 || eventCity.length >= 2 || zip.length > 0 || eventFeatures.length > 0) {
            setConfirmGoBack(true);
        } else {
            handleBack();
        }
    }

    useEffect(() => {
        const validateInitialConditions = () => {
            const anyOptionEmpty = acceptPayments === true && paymentData !== null && paymentData.status === 'verified' &&
                paymentData.purchaseOptions !== null && paymentData.purchaseOptions.length > 0 &&
                paymentData.purchaseOptions.some(option => option.name.length === 0 || option.price.length === 0 || option.availableQuantity.length === 0);
    
            if (
                uploads.length === 0 ||
                eventAddress.length < 8 ||
                eventCity.length < 2 ||
                title.length < 5 || title.length > 50 ||
                eventCategory === 'Select Category' ||
                zip.length < 5 ||
                anyOptionEmpty ||
                (acceptPayments === true && paymentData !== null && paymentData.status === 'verified' && (paymentData.purchaseOptions === null || paymentData.purchaseOptions.length === 0)) ||
                (acceptPayments && paymentData !== null && paymentData.status === 'no_account') ||
                (acceptPayments && paymentData !== null && paymentData.status === 'verified' && paymentData.balance < 20) ||
                (acceptPayments && paymentData !== null && paymentData.status === 'verified' && paymentData.refundPolicy.length < 20) ||
                phoneNumber.length !== 14
            ) {
                setCanSubmit(false);
            } else {
                setCanSubmit(true);
            }
        };
    
        const handleInputChange = () => {
            // Check validity and value of startDateRef and endDateRef
            const startDateInput = startDateRef.current;
            const endDateInput = endDateRef.current;
    
            const startDateValidity = startDateInput.validity.badInput || startDateInput.value.length === 0;
            const endDateValidity = endDateInput.validity.badInput || endDateInput.value.length === 0;
    
            if (
                uploads.length === 0 ||
                startDateValidity ||
                endDateValidity ||
                eventAddress.length < 8 ||
                eventCity.length < 2 ||
                title.length < 5 || title.length > 50 ||
                eventCategory === 'Select Category' ||
                zip.length < 5
            ) {
                setCanSubmit(false);
            } else {
                setCanSubmit(true);
            }
        };
    
        // Initial validation
        validateInitialConditions();
    
        // Add event listeners to startDateRef and endDateRef for input change validation
        const startDateInput = startDateRef.current;
        const endDateInput = endDateRef.current;
    
        startDateInput.addEventListener('input', handleInputChange);
        endDateInput.addEventListener('input', handleInputChange);
    
        // Cleanup function to remove event listeners
        return () => {
            startDateInput.removeEventListener('input', handleInputChange);
            endDateInput.removeEventListener('input', handleInputChange);
        };
    }, [uploads, phoneNumber, acceptPayments, paymentData, title, desc, eventAddress, eventCity, zip, startDateRef, endDateRef, eventCategory]);
    

    // =======================================
    // =======================================

    const memoizeImageGrid = useMemo(() => <GridDragAndDrop initialImages={null} pendingRequest={pendingRequest} receiveUploadData={(newUploads) => setUploads(newUploads)}  />, [pendingRequest])

    return (
        <section id={styles.createtrade}>

            { confirmGoBack === true && <section id={styles.confirmGoBack}>
                <div>
                    <div>
                        <h1>Discard Draft?</h1>
                        <span>
                            <button id={styles.confirm} onClick={() => handleBack()}>
                                <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                            </button>
                            <button id={styles.cancel} onClick={() => setConfirmGoBack(false)}>
                                <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                            </button>
                        </span>
                    </div>
                </div>
            </section> }

            <section id={styles.wrapper}>
                
                <FontAwesomeIcon icon={faChevronLeft} id={styles.goBack} onClick={() => handleConfirmBack()} />
                <div id={styles.gridContainer}>
                    <h1>{uploads.length} / 12 slots available</h1>
                    { memoizeImageGrid }
                </div>

                <div id={styles.enterInfo}>

                    <h1>Event Title</h1>
                    <section id={styles.title}>
                        <input disabled={pendingRequest} onChange={(e) => setTitle(e.target.value)} type='text' placeholder="Title" maxLength={50} value={title} />
                        {title !== null && ( title.length < 5 && <h6>{title.length - 5}</h6> )}
                    </section>

                    <h1>Category</h1>
                    <div onMouseLeave={() => showCategoryMenu(false)} className={styles.dropdown}>
                    <button disabled={pendingRequest} style={{color: eventCategory === 'Select Category' ? '#818181' : 'black'}} onClick={ (e) => {e.preventDefault(); showCategoryMenu(categoryMenu ? false : true)} } className={styles.dropdownBtn}>{eventCategory} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                        <div style={{height: '200px', display: categoryMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                            <button onClick={(e) => changeEventCategory(e, 'Air Show')}>Air Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Antique Auction')}>Antique Auction</button>
                            <button onClick={(e) => changeEventCategory(e, 'Aquarium Event')}>Aquarium Event</button>
                            <button onClick={(e) => changeEventCategory(e, 'Art Auction')}>Art Auction</button>
                            <button onClick={(e) => changeEventCategory(e, 'Art Opening')}>Art Opening</button>
                            <button onClick={(e) => changeEventCategory(e, 'Awards Ceremony')}>Awards Ceremony</button>
                            <button onClick={(e) => changeEventCategory(e, 'Boat Show')}>Boat Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Book Signing')}>Book Signing</button>
                            <button onClick={(e) => changeEventCategory(e, 'Carnival')}>Carnival</button>
                            <button onClick={(e) => changeEventCategory(e, 'Car Rally')}>Car Rally</button>
                            <button onClick={(e) => changeEventCategory(e, 'Charity Event')}>Charity Event</button>
                            <button onClick={(e) => changeEventCategory(e, 'Circus')}>Circus</button>
                            <button onClick={(e) => changeEventCategory(e, 'Comedy Show')}>Comedy Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Conference')}>Conference</button>
                            <button onClick={(e) => changeEventCategory(e, 'Convention')}>Convention</button>
                            <button onClick={(e) => changeEventCategory(e, 'Cultural Event')}>Cultural Event</button>
                            <button onClick={(e) => changeEventCategory(e, 'Dance Performance')}>Dance Performance</button>
                            <button onClick={(e) => changeEventCategory(e, 'Debate')}>Debate</button>
                            <button onClick={(e) => changeEventCategory(e, 'Dinosaur Exhibition')}>Dinosaur Exhibition</button>
                            <button onClick={(e) => changeEventCategory(e, 'Drama Festival')}>Drama Festival</button>
                            <button onClick={(e) => changeEventCategory(e, 'Escape Room')}>Escape Room</button>
                            <button onClick={(e) => changeEventCategory(e, 'Exhibition')}>Exhibition</button>
                            <button onClick={(e) => changeEventCategory(e, 'Fair')}>Fair</button>
                            <button onClick={(e) => changeEventCategory(e, 'Fashion Show')}>Fashion Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Farmers Market')}>Farmers Market</button>
                            <button onClick={(e) => changeEventCategory(e, 'Festival')}>Festival</button>
                            <button onClick={(e) => changeEventCategory(e, 'Film Screening')}>Film Screening</button>
                            <button onClick={(e) => changeEventCategory(e, 'Fireworks Display')}>Fireworks Display</button>
                            <button onClick={(e) => changeEventCategory(e, 'Fitness Expo')}>Fitness Expo</button>
                            <button onClick={(e) => changeEventCategory(e, 'Food Tasting')}>Food Tasting</button>
                            <button onClick={(e) => changeEventCategory(e, 'Gaming Tournament')}>Gaming Tournament</button>
                            <button onClick={(e) => changeEventCategory(e, 'Gallery Opening')}>Gallery Opening</button>
                            <button onClick={(e) => changeEventCategory(e, 'Garage Sale')}>Garage Sale</button>
                            <button onClick={(e) => changeEventCategory(e, 'Hackathon')}>Hackathon</button>
                            <button onClick={(e) => changeEventCategory(e, 'Holiday Celebration')}>Holiday Celebration</button>
                            <button onClick={(e) => changeEventCategory(e, 'Job Fair')}>Job Fair</button>
                            <button onClick={(e) => changeEventCategory(e, 'Lantern Festival')}>Lantern Festival</button>
                            <button onClick={(e) => changeEventCategory(e, 'LARP Event')}>LARP Event</button>
                            <button onClick={(e) => changeEventCategory(e, 'Lecture')}>Lecture</button>
                            <button onClick={(e) => changeEventCategory(e, 'Magic Show')}>Magic Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Meteor Shower Viewing')}>Meteor Shower Viewing</button>
                            <button onClick={(e) => changeEventCategory(e, 'Movie Screening')}>Movie Screening</button>
                            <button onClick={(e) => changeEventCategory(e, 'Music Competition')}>Music Competition</button>
                            <button onClick={(e) => changeEventCategory(e, 'Musical')}>Musical</button>
                            <button onClick={(e) => changeEventCategory(e, 'Opera')}>Opera</button>
                            <button onClick={(e) => changeEventCategory(e, 'Parade')}>Parade</button>
                            <button onClick={(e) => changeEventCategory(e, 'Play')}>Play</button>
                            <button onClick={(e) => changeEventCategory(e, 'Poetry Reading')}>Poetry Reading</button>
                            <button onClick={(e) => changeEventCategory(e, 'Product Launch')}>Product Launch</button>
                            <button onClick={(e) => changeEventCategory(e, 'Puppet Show')}>Puppet Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Renaissance Fair')}>Renaissance Fair</button>
                            <button onClick={(e) => changeEventCategory(e, 'Robotics Competition')}>Robotics Competition</button>
                            <button onClick={(e) => changeEventCategory(e, 'Robotics Expo')}>Robotics Expo</button>
                            <button onClick={(e) => changeEventCategory(e, 'Science Fair')}>Science Fair</button>
                            <button onClick={(e) => changeEventCategory(e, 'Sculpture Exhibition')}>Sculpture Exhibition</button>
                            <button onClick={(e) => changeEventCategory(e, 'Silent Disco')}>Silent Disco</button>
                            <button onClick={(e) => changeEventCategory(e, 'Spelling Bee')}>Spelling Bee</button>
                            <button onClick={(e) => changeEventCategory(e, 'Street Fair')}>Street Fair</button>
                            <button onClick={(e) => changeEventCategory(e, 'Swap Meet')}>Swap Meet</button>
                            <button onClick={(e) => changeEventCategory(e, 'Symposium')}>Symposium</button>
                            <button onClick={(e) => changeEventCategory(e, 'TED Talk')}>TED Talk</button>
                            <button onClick={(e) => changeEventCategory(e, 'Trade Show')}>Trade Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Trivia Night')}>Trivia Night</button>
                            <button onClick={(e) => changeEventCategory(e, 'Vintage Car Show')}>Vintage Car Show</button>
                            <button onClick={(e) => changeEventCategory(e, 'Workshop')}>Workshop</button>
                            <button onClick={(e) => changeEventCategory(e, 'Zoo Event')}>Zoo Event</button>
                        </div>
                    </div>

                    <h1>Schedule</h1>
                    <section id={styles.createSchedule}>
                        <input disabled={pendingRequest} ref={startDateRef} type="datetime-local" min={new Date().toISOString().slice(0, -8)} required />
                        <input disabled={pendingRequest} ref={endDateRef} type="datetime-local" min={startDateRef?.current?.value !== undefined ? new Date(startDateRef?.current?.value !== '' ? startDateRef?.current?.value : new Date()).toISOString().slice(0, -8) : new Date().toISOString().slice(0, -8)} required />
                    </section>

                    <h1>Location</h1>
                    <section id={styles.addLocation}>
                        <input disabled={pendingRequest} onChange={(e) => setEventAddress(e.target.value)} type='text' placeholder="Address" value={eventAddress} />
                        <div>
                            <input disabled={pendingRequest} onChange={(e) => setEventCity(e.target.value)} type='text' placeholder="City" value={eventCity} />
                            <input disabled={pendingRequest} onChange={handleZIPChange} type='text' placeholder="ZIP Code" maxLength={10} value={zip} />
                        </div>
                    </section>

                    <ListingMap address={eventAddress} city={eventCity} zip={zip} />

                    <h1>Contact Number</h1>
                    <input disabled={pendingRequest} type='text' placeholder="(123)-456-7890" onChange={handleChange} value={phoneNumber} />

                    <section id={styles.paymentContainer}>
                        <h1>Accept Online Payments</h1>
                        <ToggleSwitch state={acceptPayments} setState={setAcceptPayments} />
                    </section>

                    { acceptPayments === true && <AcceptPayments session={session} pendingRequest={pendingRequest} setAcceptPayments={setAcceptPayments} paymentData={paymentData} setPaymentData={setPaymentData} /> }

                    <h1>Additional Details</h1>

                    <section id={styles.addFeatures}>
                        <div>
                            <input ref={featureRef} onKeyDown={(e) => (e.key === "Enter") && addEventFeature()} type='text' placeholder="Add amenity" />
                            <FontAwesomeIcon onClick={() => addEventFeature()} icon={faPlusCircle} id={styles.icon} />
                        </div>
                        <div>
                            { eventFeatures.map((feature, index) => {
                                return <h1 key={index}>{feature} <FontAwesomeIcon onClick={() => removeEventFeature(index)} icon={faMinusCircle} id={styles.icon} /></h1>
                            }) }
                        </div>
                    </section>

                    <section id={styles.desc}>
                        <textarea disabled={pendingRequest} onChange={(e) => setDesc(e.target.value)} placeholder="Description" maxLength={2000} />
                    </section>

                    <p>Event listings are public and can be seen by anyone on or off Waco Exchange. Events promoting illegal or inappropriate content are not allowed on Waco Exchange. See our <b onClick={() => showPolicyPage(true)}>Policy Page</b> for more info.</p>
                    <button disabled={!canSubmit} onClick={handleSubmit} id={styles.createListing}>
                        { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Create Listing <FontAwesomeIcon icon={faPlusSquare} id={styles.icon} /> { paymentData?.due && <>- {paymentData?.due} <FontAwesomeIcon icon={faCoins} id={styles.icon} /></> }  </>}
                    </button>

                </div>
            </section>
        </section>
    )
}

const AcceptPayments = ({ session, pendingRequest, setAcceptPayments, paymentData, setPaymentData }) => {

    const [loading, setLoading] = useState(null);
    const [financeAcc, setFinanceAccount] = useState(null);

    const getPurchaseOptions = paymentData?.purchaseOptions !== undefined ? paymentData.purchaseOptions : null

    useEffect(() => {
        if(loading !== null) return;

        async function getFinanceAccount() {
            if(loading === true) return;
            setLoading(true);

            const result = await axios.post(`${window.location.origin}/api/finance/account/purchasePower`, {
                userID: session.user.token.id
            }).catch((error) => {
                errorMsg(error.toString())
            })

            if(result && result.status === 200) {
                const accData = result.data;
                if(accData.acc === false) {
                    setFinanceAccount(false);
                    setPaymentData({
                        status: 'no_account',
                        due: 20
                    })
                } else {
                    setFinanceAccount(accData.acc);
                    const generateUniqueItemID = session.user.token.id.substring(0, 8) + Math.random().toString(36).substring(2, 9)
                    setPaymentData({
                        status: 'verified',
                        due: 20,
                        balance: accData.acc,
                        purchaseOptions: [ { id: generateUniqueItemID, name: '', price: '', desc: '', availableQuantity: 0, merchantUserID: session.user.token.id } ],
                        refundPolicy: '',
                    })
                }
            }

            setLoading(false);
        }

        getFinanceAccount();

    }, [session])

    function isLoading() {
        if(loading === true) return true;
        if(loading === null) return true;
        if(financeAcc === null) return true;
        return false;
    }

    function handleCreateFinanceAccount() {
        if(pendingRequest === true) return;
        window.open(`${window.location.origin}/financehub`, '_blank')
        setAcceptPayments(false)
    }

    function handleNavigateBuyCoins() {
        if(pendingRequest === true) return;
        window.open(`${window.location.origin}/financehub/?navigate=purchaseCoins`, '_blank')
        setAcceptPayments(false)
    }

    const addPurchaseOption = () => {
        if(pendingRequest === true) return;
        if(paymentData === null) return;

        const generateUniqueItemID = session.user.token.id.substring(0, 8) + Math.random().toString(36).substring(2, 9)

        setPaymentData(prevState => ({
            ...prevState,
            purchaseOptions: [
                ...prevState.purchaseOptions,
                { id: generateUniqueItemID, name: '', price: '', desc: '', availableQuantity: 0, merchantUserID: session.user.token.id }
            ]
        }));
    };

        // Function to handle change in name input
        const handleNameChange = (index, name) => {
            if(pendingRequest === true) return;
            setPaymentData(prevState => ({
                ...prevState,
                purchaseOptions: prevState.purchaseOptions.map((option, i) => {
                    if (i === index) {
                        return { ...option, name };
                    }
                    return option;
                })
            }));
        };
    
        // Function to handle change in price input
        const handlePriceChange = (index, price) => {
            if(pendingRequest === true) return;
            setPaymentData(prevState => ({
                ...prevState,
                purchaseOptions: prevState.purchaseOptions.map((option, i) => {
                    if (i === index) {
                        return { ...option, price };
                    }
                    return option;
                })
            }));
        };

        // Function to handle change in quantity input
        const handleQuantityChange = (index, availableQuantity) => {
            if (pendingRequest === true) return;
            // Convert availableQuantity to integer using parseInt with radix 32
            const parsedQuantity = availableQuantity.toString().length === 0 ? availableQuantity : parseInt(availableQuantity);
            setPaymentData(prevState => ({
                ...prevState,
                purchaseOptions: prevState.purchaseOptions.map((option, i) => {
                    if (i === index) {
                        return { ...option, availableQuantity: parsedQuantity };
                    }
                    return option;
                })
            }));
        };

        // Function to handle change in description textarea
        const handleDescChange = (index, desc) => {
            if(pendingRequest === true) return;
            setPaymentData(prevState => ({
                ...prevState,
                purchaseOptions: prevState.purchaseOptions.map((option, i) => {
                    if (i === index) {
                        return { ...option, desc };
                    }
                    return option;
                })
            }));
        };

        // Function to handle change in description textarea
        const handleRefundPolicyChange = (event) => {
            if(pendingRequest === true) return;
            const { value } = event.target;
            setPaymentData(prevPaymentData => ({
                ...prevPaymentData,
                refundPolicy: value
            }));
        };
        

    return (
        <section id={styles.acceptPayments}>
            { isLoading() && <div id={styles.loading}><BarLoader color='#0da00d' width='100%' height='6px' /></div> }
            { !isLoading() && <>
            { financeAcc === false && <button disabled={pendingRequest} onClick={handleCreateFinanceAccount} id={styles.signup}>Signup for Finance Account</button> }
            { financeAcc !== false && <div id={styles.container}>

                <section id={styles.options}>
                    <h1 onClick={handleNavigateBuyCoins}><FontAwesomeIcon icon={faCoins} id={styles.icon} /> <b>{financeAcc}</b></h1>
                    <button disabled={pendingRequest} onClick={addPurchaseOption}>Add Item</button>
                </section>

                <section id={styles.purchaseOptions}>
                    { getPurchaseOptions !== null && getPurchaseOptions.map((option, index) => {

                    // Function to remove a purchase option by id
                    const removePurchaseOption = () => {
                        if(paymentData === null) return;
                        if(pendingRequest === true) return;
                        setPaymentData(prevState => ({
                            ...prevState,
                            purchaseOptions: prevState.purchaseOptions.filter(opt => opt.id !== option.id)
                        }));
                    };

                        return (
                            <div className={styles.option} key={option.id}>
                            <h1>
                                Item {index + 1} 
                                <FontAwesomeIcon onClick={() => removePurchaseOption(option.id)} icon={faMinusCircle} id={styles.remove} />
                            </h1>
                            <section>
                                <input 
                                    type='text' 
                                    placeholder="Admission" 
                                    value={option.name} 
                                    onChange={(e) => handleNameChange(index, e.target.value)}
                                    disabled={pendingRequest}
                                />
                                <NumberFormat 
                                    value={option.price} 
                                    onValueChange={({ value }) => handlePriceChange(index, value)} 
                                    isAllowed={priceValueCap} 
                                    decimalSeparator={false} 
                                    placeholder="Price" 
                                    thousandSeparator={true} 
                                    prefix={'$'} 
                                />
                                <NumberFormat 
                                    value={option.availableQuantity} 
                                    onValueChange={({ value }) => handleQuantityChange(index, value)} 
                                    decimalSeparator={false} 
                                    placeholder="Qty" 
                                    thousandSeparator={true}
                                    suffix=' qty'
                                />
                            </section>
                            <textarea disabled={pendingRequest}
                                placeholder="Optional details" 
                                value={option.desc} 
                                onChange={(e) => handleDescChange(index, e.target.value)} 
                            />
                        </div>
                        )
                    }) }
                </section>

                <section id={styles.desc} style={{height: '80px'}}>
                    <textarea disabled={pendingRequest} placeholder="Refund Policy (required)" onChange={handleRefundPolicyChange} value={paymentData.refundPolicy} maxLength={2000} />
                    {paymentData.refundPolicy !== null && ( paymentData.refundPolicy.length < 20 && <h6>{paymentData.refundPolicy.length - 20}</h6> )}
                </section>

            </div> }
            </> }
        </section>
    )
}

const priceValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000) return true;
    return false;
};

const ListingMap = ({ address, city, zip }) => {

    function isMapViewable() {
        if(zip === null || zip === undefined) return false;
        if(zip.length === 5 || zip.length === 10) return true;
        return false;
    }

    return (
        <section id={styles.listingInteractiveMap}>
            { isMapViewable() && <MapWithLocation address={address} city={city} zipCode={zip} /> }
            { !isMapViewable() && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
        </section>
    )
}